import React from 'react';
import { CreditCard } from 'lucide-react';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export default function PaymentStep({
  referralSource,
  setReferralSource,
  totalWithTax,
  REFERRAL_OPTIONS
}) {
  return (
    <div className="animate-fade-in text-center py-8" data-testid="cleaning-step-6">
      <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
        <CreditCard className="w-8 h-8 text-emerald-600" />
      </div>
      <h2 className="text-2xl font-bold text-slate-900 font-['Outfit'] mb-2">Ready to Pay</h2>
      <p className="text-slate-500 mb-4">You'll be redirected to our secure payment page</p>
      
      <div className="max-w-md mx-auto mb-8 text-left">
        <Label className="text-slate-700 font-medium mb-2 block">How did you hear about us? *</Label>
        <Select value={referralSource} onValueChange={setReferralSource}>
          <SelectTrigger className="w-full h-12" data-testid="referral-source-select">
            <SelectValue placeholder="Select an option" />
          </SelectTrigger>
          <SelectContent>
            {REFERRAL_OPTIONS.map((opt) => (
              <SelectItem key={opt} value={opt}>{opt}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <p className="text-3xl font-bold text-emerald-600 font-['Outfit']">${totalWithTax}</p>
      <p className="text-sm text-slate-400 mt-1">Including NJ 6.625% sales tax</p>
    </div>
  );
}
